<template>
  <div class="privileges">
    <el-dialog
      title="分配权限"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="860px"
      :before-close="handleClose"
    >
      <div v-loading="dialogLoading">
        <tree-table
          ref="menu-tree"
          style="max-height: 500px; overflow: auto"
          expand-key="menuName"
          :expand-type="false"
          :is-fold="false"
          :tree-type="true"
          :selectable="true"
          :columns="selectMenusTableConfig"
          :data="selectMenus"
        >
          <template v-slot:operation="{ row }">
            <el-checkbox-group v-model="grantActions">
              <el-checkbox
                v-for="item in row.actionList"
                :key="item.authorityId"
                :label="item.authorityId"
                name="grant"
                >{{ item.actionName }}</el-checkbox
              >
            </el-checkbox-group>
          </template>
        </tree-table>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">关 闭</el-button>
        <el-button size="small" type="primary" @click="handleAffirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAuthorityproxyMenu,
  getAuthoritysubProxyMenu,
  getAuthorityRole,
  grantAuthorityRole,
} from "@/api/organization";
import { listConvertTree } from "@/api/util.js";
export default {
  data() {
    return {
      dialogVisible: false,
      dialogLoading: false,
      grantMenus: [],
      grantActions: [],
      selectMenus: [],
      roleId: "",
      selectMenusTableConfig: [
        {
          title: "菜单",
          key: "menuName",
          // headerAlign: "center",
          // align: "center",
          minWidth: "240px",
        },
        {
          title: "功能",
          type: "template",
          // headerAlign: "center",
          // align: "center",
          template: "operation",
          minWidth: "310px",
        },
      ],
      status: ""
    };
  },
  methods: {
    // 初始化
    init(status, roleId) {
      this.status = status;
      this.roleId = roleId;
      this.grantMenus = [];
      this.grantActions = [];
      this.selectMenus = [];
      this.allotMenu(roleId);
    },
    allotMenu(roleId) {
      if (!roleId) {
        this.$message.warning("编辑信息有误, 请联系管理员!");
        return;
      }
      this.dialogVisible = true;
      this.dialogLoading = true;
      const p1 = this.status === "agency" ? getAuthorityproxyMenu() : getAuthoritysubProxyMenu();
      const p2 = getAuthorityRole({ roleId });
      Promise.all([p1, p2])
        .then((respArr) => {
          const menus = respArr[0].code === 0 ? respArr[0].data : null;
          const aUser = respArr[1].code === 0 ? respArr[1].data : null;
          if (aUser && aUser.length > 0) {
            for (const item of aUser) {
              // 菜单权限
              if (item.authority.indexOf("MENU_") !== -1) {
                this.grantMenus.push(item.authorityId);
              }
              // 操作权限
              if (item.authority.indexOf("ACTION_") !== -1) {
                this.grantActions.push(item.authorityId);
              }
            }
          }
          if (menus && menus.length > 0) {
            const config = {
              primaryKey: "menuId",
              parentKey: "parentId",
              startPid: "0",
            };
            for (const item of menus) {
              // 菜单选中
              if (this.grantMenus.includes(item.authorityId)) {
                item._isChecked = true;
              }
            }
            this.selectMenus = listConvertTree(menus, config);
          }
          this.dialogLoading = false;
        })
        .finally(() => {
          this.dialogLoading = false;
        });
    },
    // 取消
    handleClose() {
      this.dialogVisible = false;
    },
    // 确认
    handleAffirm() {
      this.submitLoading = true;
      const authorityIds = this.getCheckedAuthorities();
      const params = {
        roleId: this.roleId,
        authorityIds: authorityIds.join(","),
      };
      grantAuthorityRole(params)
        .then((resp) => {
          this.submitLoading = false;
          if (resp.code === 0) {
            this.$parent.refresh();
            this.$message.success("分配权限成功!");
            this.dialogVisible = false;
          }
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    getCheckedAuthorities() {
      const menus = this.$refs["menu-tree"].getCheckedProp("authorityId");
      return menus.concat(this.grantActions);
    },
  },
};
</script>